/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../../common/currency';
import '../api/common';
import './refund';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "model": {
            "nested": {
              "RecordedTransaction": {
                "fields": {
                  "createdAtMs": {
                    "type": "int64",
                    "id": 1,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 2,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 12,
                    "rule": "optional"
                  },
                  "totalMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "tipMoney": {
                    "type": "squareup.common.Money",
                    "id": 4,
                    "rule": "optional"
                  },
                  "taxMoney": {
                    "type": "squareup.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": "squareup.esperanto.api.Merchant",
                    "id": 6,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.esperanto.model.RecordedTransactionStatus",
                    "id": 7,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.esperanto.model.RecordedTransactionType",
                    "id": 8,
                    "rule": "optional"
                  },
                  "refund": {
                    "type": "squareup.esperanto.model.RecordedTransactionRefund",
                    "id": 11,
                    "rule": "repeated"
                  },
                  "cashPaymentDetails": {
                    "type": "squareup.esperanto.model.CashPaymentDetails",
                    "id": 9
                  },
                  "externalSourceDetails": {
                    "type": "squareup.esperanto.model.ExternalSourceDetails",
                    "id": 10
                  }
                },
                "nested": {
                  "payment_type_details": {
                    "oneof": ["cashPaymentDetails", "externalSourceDetails"]
                  }
                }
              },
              "RecordedTransactionStatus": {
                "values": {
                  "DO_NOT_USE": 0,
                  "CREATED": 1,
                  "COMPLETED": 2,
                  "CANCELED": 3,
                  "FAILED": 4
                }
              },
              "RecordedTransactionType": {
                "values": {
                  "DEFAULT_ENUM_DO_NOT_USE": 0,
                  "CASH": 1,
                  "CHECK": 2,
                  "BANK_TRANSFER": 3,
                  "OTHER_GIFT_CARD": 4,
                  "CRYPTO": 5,
                  "SQUARE_CASH": 6,
                  "SOCIAL": 7,
                  "EXTERNAL": 8,
                  "EMONEY": 9,
                  "CARD": 10,
                  "STORED_BALANCE": 12,
                  "FOOD_VOUCHER": 13,
                  "OTHER": 11
                }
              },
              "CashPaymentDetails": {
                "fields": {
                  "buyerSuppliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "changeBackMoney": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cashDrawerMetadata": {
                    "type": "squareup.esperanto.model.CashDrawerMetadata",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "CashDrawerMetadata": {
                "fields": {
                  "shiftId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientEventId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ExternalSourceDetails": {
                "fields": {
                  "sourceDescription": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sourceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "sourceFeeMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "RecordedTransactionRefund": {
                "fields": {
                  "refundUuid": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "refundRequestIdempotenceKey": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": "squareup.common.Money",
                    "id": 3,
                    "rule": "optional"
                  },
                  "createdAtMs": {
                    "type": "int64",
                    "id": 4,
                    "rule": "optional"
                  },
                  "completedAtMs": {
                    "type": "int64",
                    "id": 9,
                    "rule": "optional"
                  },
                  "canceledAtMs": {
                    "type": "int64",
                    "id": 10,
                    "rule": "optional"
                  },
                  "updatedAtMs": {
                    "type": "int64",
                    "id": 13,
                    "rule": "optional"
                  },
                  "status": {
                    "type": "squareup.esperanto.model.RecordedTransactionRefund.RecordedRefundStatus",
                    "id": 5,
                    "rule": "optional"
                  },
                  "refundOrderId": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "options": {
                    "type": "squareup.esperanto.model.RefundOptions",
                    "id": 7,
                    "rule": "optional"
                  },
                  "type": {
                    "type": "squareup.esperanto.model.RecordedTransactionType",
                    "id": 11,
                    "rule": "optional"
                  },
                  "cashDetails": {
                    "type": "squareup.esperanto.model.CashRefundDetails",
                    "id": 12,
                    "rule": "optional"
                  },
                  "externalDestinationDetails": {
                    "type": "squareup.esperanto.model.ExternalDestinationDetails",
                    "id": 8,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RecordedRefundStatus": {
                    "values": {
                      "DO_NOT_USE": 0,
                      "PENDING": 1,
                      "COMPLETED": 2,
                      "CANCELED": 3
                    }
                  }
                }
              },
              "CashRefundDetails": {
                "fields": {
                  "sellerSuppliedMoney": {
                    "type": "squareup.common.Money",
                    "id": 1,
                    "rule": "optional"
                  },
                  "changeBackMoney": {
                    "type": "squareup.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "cashDrawerMetadata": {
                    "type": "squareup.esperanto.model.CashDrawerMetadata",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "ExternalDestinationDetails": {
                "fields": {
                  "sourceDescription": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "sourceId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RecordedTransaction && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RecordedTransactionStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RecordedTransactionType && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CashPaymentDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CashDrawerMetadata && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.ExternalSourceDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RecordedTransactionRefund && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.RecordedTransactionRefund?.nested?.RecordedRefundStatus && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.CashRefundDetails && !$root.nested?.squareup?.nested?.esperanto?.nested?.model?.nested?.ExternalDestinationDetails) {
  $root.addJSON(jsonData);
}

/**
 * Recorded transaction for an external/cash payment.
 *
 * SOURCE RecordedTransaction @ squareup/esperanto/model/recorded.proto at 14:1
 */
export const RecordedTransaction = $root.lookupType('squareup.esperanto.model.RecordedTransaction');
fixType(RecordedTransaction);
Builder.createAndAttachToType(RecordedTransaction);
/**
 * SOURCE RecordedTransactionStatus @ squareup/esperanto/model/recorded.proto at 62:1
 */
export const RecordedTransactionStatus = $root.lookupEnum('squareup.esperanto.model.RecordedTransactionStatus').values;
/**
 * SOURCE RecordedTransactionType @ squareup/esperanto/model/recorded.proto at 70:1
 */
export const RecordedTransactionType = $root.lookupEnum('squareup.esperanto.model.RecordedTransactionType').values;
/**
 * Details specific to CASH type payments.
 *
 * SOURCE CashPaymentDetails @ squareup/esperanto/model/recorded.proto at 118:1
 */
export const CashPaymentDetails = $root.lookupType('squareup.esperanto.model.CashPaymentDetails');
fixType(CashPaymentDetails);
Builder.createAndAttachToType(CashPaymentDetails);
/**
 * Metadata about the cash drawer provided by clients at the time of the payment or refund.
 *
 * SOURCE CashDrawerMetadata @ squareup/esperanto/model/recorded.proto at 130:1
 */
export const CashDrawerMetadata = $root.lookupType('squareup.esperanto.model.CashDrawerMetadata');
fixType(CashDrawerMetadata);
Builder.createAndAttachToType(CashDrawerMetadata);
/**
 * Optional details about the payment from an external source.
 *
 * SOURCE ExternalSourceDetails @ squareup/esperanto/model/recorded.proto at 141:1
 */
export const ExternalSourceDetails = $root.lookupType('squareup.esperanto.model.ExternalSourceDetails');
fixType(ExternalSourceDetails);
Builder.createAndAttachToType(ExternalSourceDetails);
/**
 * Refund for a recorded transaction
 *
 * SOURCE RecordedTransactionRefund @ squareup/esperanto/model/recorded.proto at 162:1
 */
export const RecordedTransactionRefund = $root.lookupType('squareup.esperanto.model.RecordedTransactionRefund');
fixType(RecordedTransactionRefund);
Builder.createAndAttachToType(RecordedTransactionRefund);
/**
 * SOURCE RecordedRefundStatus @ squareup/esperanto/model/recorded.proto at 199:3
 */
RecordedTransactionRefund.RecordedRefundStatus = $root.lookupEnum('squareup.esperanto.model.RecordedTransactionRefund.RecordedRefundStatus').values;
/**
 * Details specific to CASH type refunds.
 *
 * SOURCE CashRefundDetails @ squareup/esperanto/model/recorded.proto at 232:1
 */
export const CashRefundDetails = $root.lookupType('squareup.esperanto.model.CashRefundDetails');
fixType(CashRefundDetails);
Builder.createAndAttachToType(CashRefundDetails);
/**
 * Optional details about the refund to an external destination.
 *
 * SOURCE ExternalDestinationDetails @ squareup/esperanto/model/recorded.proto at 246:1
 */
export const ExternalDestinationDetails = $root.lookupType('squareup.esperanto.model.ExternalDestinationDetails');
fixType(ExternalDestinationDetails);
Builder.createAndAttachToType(ExternalDestinationDetails);